var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCulbGlobalMenuIcon = function SvgCulbGlobalMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16V15.25C2 12.3505 4.23858 10 7 10C9.76143 10 12 12.3505 12 15.25V16",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.6364C11 9.62807 12.567 8 14.5 8C16.433 8 18 9.62807 18 11.6364V12",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10C8.65683 10 10 8.65683 10 7C10 5.34314 8.65683 4 7 4C5.34314 4 4 5.34314 4 7C4 8.65683 5.34314 10 7 10Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8C15.8807 8 17 6.88071 17 5.5C17 4.11929 15.8807 3 14.5 3C13.1192 3 12 4.11929 12 5.5C12 6.88071 13.1192 8 14.5 8Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCulbGlobalMenuIcon;